// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks } from '@generouted/solid-router/client'

export type Path =
  | `/`
  | `/admin`
  | `/admin/automatizaciones`
  | `/admin/automatizaciones/:id`
  | `/admin/automatizaciones/credenciales`
  | `/admin/builder`
  | `/admin/builder/componentes`
  | `/admin/builder/modelos`
  | `/admin/builder/paginas`
  | `/admin/builder/paginas/:id`
  | `/admin/builder/temas`
  | `/admin/chat`
  | `/admin/clientes`
  | `/admin/clientes/:id`
  | `/admin/configuracion`
  | `/admin/configuracion/auditoria`
  | `/admin/configuracion/correo`
  | `/admin/configuracion/ia`
  | `/admin/configuracion/pagos`
  | `/admin/cotizaciones`
  | `/admin/cotizaciones/:id`
  | `/admin/cotizaciones/nueva`
  | `/admin/crm`
  | `/admin/cuentas-cobro`
  | `/admin/cuentas-cobro/:id`
  | `/admin/cuentas-cobro/nueva`
  | `/admin/empresas`
  | `/admin/empresas/:id`
  | `/admin/esperando-empresa`
  | `/admin/formularios`
  | `/admin/formularios/:id`
  | `/admin/formularios/respuestas/:id`
  | `/admin/inventario`
  | `/admin/parametros`
  | `/admin/pedidos`
  | `/admin/pedidos/:id`
  | `/admin/perfil`
  | `/admin/prospectos`
  | `/admin/roles`
  | `/admin/servicios`
  | `/admin/servicios/:id`
  | `/admin/servicios/nuevo`
  | `/admin/usuarios`
  | `/admin/usuarios/:id`
  | `/catalogo/:empresa`
  | `/catalogo/:empresa/:key`
  | `/catalogo/:empresa/carrito`
  | `/catalogo/:empresa/pago`
  | `/catalogo/:empresa/pedido/:numero`
  | `/componentes`
  | `/componentes/accordion`
  | `/componentes/accordion-group`
  | `/componentes/alert`
  | `/componentes/avatar`
  | `/componentes/badge`
  | `/componentes/breadcrumbs`
  | `/componentes/button`
  | `/componentes/button-group`
  | `/componentes/card`
  | `/componentes/checkbox`
  | `/componentes/chip`
  | `/componentes/color-picker`
  | `/componentes/container`
  | `/componentes/date-input`
  | `/componentes/drawer`
  | `/componentes/drawer-item`
  | `/componentes/editor-input`
  | `/componentes/file-input`
  | `/componentes/footer`
  | `/componentes/form`
  | `/componentes/gallery`
  | `/componentes/go-back`
  | `/componentes/icon`
  | `/componentes/image-viewer`
  | `/componentes/input`
  | `/componentes/list`
  | `/componentes/map`
  | `/componentes/mask-input`
  | `/componentes/menu`
  | `/componentes/modal`
  | `/componentes/radio`
  | `/componentes/rating`
  | `/componentes/select`
  | `/componentes/select-modal`
  | `/componentes/sidebar-menu`
  | `/componentes/skeleton`
  | `/componentes/slider`
  | `/componentes/swipe-action`
  | `/componentes/switch`
  | `/componentes/table`
  | `/componentes/tabs`
  | `/componentes/tag-input`
  | `/componentes/tags`
  | `/componentes/textarea`
  | `/componentes/tooltip`
  | `/componentes/update-banner`
  | `/componentes/use-alert`
  | `/componentes/use-toast`
  | `/f/:slug`
  | `/foundation/colors`
  | `/foundation/typography`
  | `/login`
  | `/oauth-callback`
  | `/p/:slug`
  | `/recuperar`

export type Params = {
  '/admin/automatizaciones/:id': { id: string }
  '/admin/builder/paginas/:id': { id: string }
  '/admin/clientes/:id': { id: string }
  '/admin/cotizaciones/:id': { id: string }
  '/admin/cuentas-cobro/:id': { id: string }
  '/admin/empresas/:id': { id: string }
  '/admin/formularios/:id': { id: string }
  '/admin/formularios/respuestas/:id': { id: string }
  '/admin/pedidos/:id': { id: string }
  '/admin/servicios/:id': { id: string }
  '/admin/usuarios/:id': { id: string }
  '/catalogo/:empresa': { empresa: string }
  '/catalogo/:empresa/:key': { empresa: string; key: string }
  '/catalogo/:empresa/carrito': { empresa: string }
  '/catalogo/:empresa/pago': { empresa: string }
  '/catalogo/:empresa/pedido/:numero': { empresa: string; numero: string }
  '/f/:slug': { slug: string }
  '/p/:slug': { slug: string }
}

export type ModalPath = never

export const { A, Navigate } = components<Path, Params>()
export const { useMatch, useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
